import React from 'react';

const Sparkline = ({
  values = [],
  width = 48,
  height = 6,
  stroke = 'currentColor',
  strokeWidth = 1,
  className = '',
}) => {
  if (!values.length) {
    return <svg width={width} height={height} className={className} />;
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const step = values.length > 1 ? width / (values.length - 1) : 0;
  const points = values
    .map((v, i) => `${(i * step).toFixed(2)},${(height - ((v - min) / span) * height).toFixed(2)}`)
    .join(' ');
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      className={className}
      style={{ display: 'block' }}
    >
      <polyline points={points} fill="none" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
};

export default Sparkline;
